import Select from "../../atoms/input/Select";

const AdminExamRoomSelect = (props) => {
  return (
    <Select
      {...props}
      className="btn btn-secondary dropdown-toggle dropdown-btn"
    />
  );
};
export default AdminExamRoomSelect;
